import { Observable } from "rxjs";

export interface FilterConfig {
    key: string;
    type: 'text' | 'number' | 'date' | 'range' | 'options';
    label: string;
    labelAr: string;
    options?: OptionFilter[] ;
    optionsFnc?: ((pageNumber: number, pageSize: number, term: string, advancedFilter: Filter[]) => Observable<OptionFilter[]>);
    allowedOperators?: { key: string, label: string, labelAr: string }[];
    /** When true with type "options", filter UI allows multiple IDs and sends IN to the API. */
    multiSelect?: boolean;
}

export interface AppliedFilter {
    key: string;
    operator: { key: string, label: string, labelAr: string };
    value: any;
    valueDes: any;
    label: string;
    labelAr: string;
}

export interface OptionFilter {
    key: any;
    label: string;
    labelAr: string;
}

export interface Filter {
    "logic": string,
    "field": string,
    "operator": string,
    "value": any
}

enum FilterOperator {
    EQ,
    NEQ,
    LT,
    LTE,
    GT,
    GTE,
    STARTSWITH,
    ENDSWITH,
    CONTAINS,
}

enum FilterLogic {
    AND, //"and";
    OR,// = "or";
    XOR// = "xor";
}

export const OperatorEnum: { key: string, label: string, labelAr: string }[] = [
    { key: "EQ", label: "Equal", labelAr: "يساوي" },
    { key: "NEQ", label: "Not equal", labelAr: "لا يساوي" },
    { key: "GT", label: "Greater than", labelAr: "أكثر من" },
    { key: "GTE", label: "Greater than or equal", labelAr: "أكثر من أو يساوي" },
    { key: "LT", label: "Less than", labelAr: "أقل من" },
    { key: "LTE", label: "Less than or equal", labelAr: "أقل من أو يساوي" },
    { key: "STARTSWITH", label: "Starts with", labelAr: "يبدأ بـ" },
    { key: "ENDSWITH", label: "Ends with", labelAr: "ينتهي بـ" },
    { key: "CONTAINS", label: "Contains", labelAr: "يحتوي على" },
];

export const BooleanOperatorEnum: { key: string, label: string, labelAr: string }[] = [
    { key: "EQ", label: "Equal", labelAr: "يساوي" },
    { key: "NEQ", label: "Not equal", labelAr: "لا يساوي" },
];

export const TextOeratorEnum: { key: string, label: string, labelAr: string }[] = [
    { key: "EQ", label: "Equal", labelAr: "يساوي" },
    { key: "NEQ", label: "Not equal", labelAr: "لا يساوي" },
    { key: "STARTSWITH", label: "Starts with", labelAr: "يبدأ بـ" },
    { key: "ENDSWITH", label: "Ends with", labelAr: "ينتهي بـ" },
    { key: "CONTAINS", label: "Contains", labelAr: "يحتوي على" },
];

export const NumberOperatorEnum: { key: string, label: string, labelAr: string }[] = [
    { key: "EQ", label: "Equal", labelAr: "يساوي" },
    { key: "NEQ", label: "Not equal", labelAr: "لا يساوي" },
    { key: "GT", label: "Greater than", labelAr: "أكثر من" },
    { key: "GTE", label: "Greater than or equal", labelAr: "أكثر من أو يساوي" },
    { key: "LT", label: "Less than", labelAr: "أقل من" },
    { key: "LTE", label: "Less than or equal", labelAr: "أقل من أو يساوي" },
];

export const EqualOperatorEnum: { key: string, label: string, labelAr: string }[] = [
    { key: "EQ", label: "Equal", labelAr: "يساوي" },
];